import type { SanityPageBuilderGraphicCardsCard, SanityPageBuilderGraphicCardsSection, SanityPageBuilderSection } from "@ouster/shared";
import { GraphicCardsBlockView } from "~/features/blocks/inventory/graphic-cards";
import { GraphicCardsCardView, type GraphicCardsCardViewProps } from "~/features/blocks/inventory/graphic-cards/graphic-cards-card";
import { toCraftAsset } from "~/features/sanity/media";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderGraphicCardsSection;
  };
};
type GraphicCardsViewCard = Omit<GraphicCardsCardViewProps, "count"> & Pick<SanityPageBuilderGraphicCardsCard, "_key">;
export function SanityGraphicCardsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.cards?.map<GraphicCardsViewCard>(card => ({
    _key: card._key,
    image: toCraftAsset(card.image),
    text: card.text?.length ? <SanityRichText value={card.text} /> : undefined,
    title: card.title
  })) ?? [];
  return <GraphicCardsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} getItemKey={(card, index) => card._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} renderCard={(card, _index, count) => <GraphicCardsCardView count={count} image={card.image} text={card.text} title={card.title} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}